import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Tooltip,
  Button,
} from "@mui/material";
import { UseProductGroup } from "../../../basic-information/productGroup/UseProductGroup";
import { useSnackbar } from "notistack";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { rsProgress, rsParentChilds } from "../../../RecoilStates";
import ProductGroupsChilds from "../../../basic-information/productGroup/ProductGroupsChilds";
import { useRecoilState } from "recoil";
import CustomPagination from "../../../components/CustomPagination";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function SelectGroup(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { enqueueSnackbar } = useSnackbar();
  const { getGroupList } = UseProductGroup();
  const [filtered, setFiltered] = useState([]);
  const [parentID, setParentID] = useRecoilState(rsParentChilds);
  const [searchToShow, setSearchToShow] = useState("");
  const [searchState, setSearchState] = useState("");
  const [PageScrollTo, setPageScrollTo] = useState(undefined);
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setProgress(true);
    getGroupList(
      searchToShow,
      (productgroups) => {
        setProgress(false);
        setFiltered(productgroups.productGroups);
      },
      false
    );
  }, [searchToShow]);

  const [level4, setLevel4] = React.useState({
    groupID: undefined,
  });

  useEffect(() => {
    if (props.selectedGroupID) {
      setLevel4({ groupID: props.selectedGroupID });
    } else if (!props.selectedGroupID) {
      setParentID({
        id: null,
        name: undefined,
      });
      setLevel4({ groupID: undefined });
      setSearchToShow("");
    }
  }, [props.selectedGroupID]);

  function gotStoreId(id, faName) {
    if (props.orderGift) {
      props.setName(faName);
      enqueueSnackbar("گروه (( " + [faName] + "  )) با موفقیت  انتخاب شد .", {
        variant: "success",
        autoHideDuration: 3000,
        preventDuplicate: true,
      });
      props.setter({
        ...props.lvl1State,
        value: id,
      });
      setLevel4({ groupID: id });
      return;
    }
    if (props.article) {
      // props.setName(faName);
      props.setter({
        ...props.lvl1State,
        name: faName,
        productGroupID: id,
      });
      setLevel4({ groupID: id });
      // enqueueSnackbar("گروه (( " + [faName] + "  )) با موفقیت  انتخاب شد .", {
      //   variant: "success",
      //   autoHideDuration: 3000,
      //   preventDuplicate: true,
      // });
      return;
    }
    if (props.slaveID) {
      setLevel4({ groupID: id });
      props.setter({
        ...props.lvl1State,
        slaveID: id,
      });
      return;
    }
    if (props.Gift) {
      setLevel4({ groupID: id });
      props.setter({
        ...props.lvl1State,
        groupID: id,
        productID: undefined,
        brandID: undefined,
        minCost: 0,
        maxCost: 0,
        giftID: undefined,
      });
      return;
    }
    props.setter({
      ...props.lvl1State,
      groupID: id,
    });
    setLevel4({ groupID: id });
    if (props.Offer) {
      props.setName(faName);
    }
    enqueueSnackbar("گروه (( " + [faName] + "  )) با موفقیت  انتخاب شد .", {
      variant: "success",
      autoHideDuration: 3000,
      preventDuplicate: true,
    });
  }

  const columns = [
    {
      field: "id",
      width: 60,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "faName",
      headerName: "نام فارسی",
      width: 250,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "زیرگروه ها",
      sortable: false,
      width: 100,
      align: "center",
      headerAlign: "center",
      headerName: "زیرگروه ها",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="Childs">
            <IconButton
              onClick={() => {
                setParentID({
                  id: cellValues.row.id,
                  name: cellValues.row.faName,
                });
              }}
            >
              <ArrowLeftIcon sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 90,
      align: "center",
      headerAlign: "center",
      hide: props.slaveID ? true : false,
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Button
            fontSize="small"
            color="secondary"
            variant="contained"
            onClick={() => {
              setParentID({
                id: null,
                name: undefined,
              });
              gotStoreId(cellValues.row.id, cellValues.row.faName);
            }}
          >
            انتخاب
          </Button>
        );
      },
    },
  ];

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(12, 1fr)"
      gap={3}
      sx={{ width: "100%", height: "31rem !important", mb: 10 }}
    >
      <Box gridColumn={isSmall ? "span 12" : "span 6"}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            placeholder="جستجو گروه"
            size="small"
            sx={{ mb: 2 }}
            variant="outlined"
            value={searchState}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              if (evt.target.value == "") {
                setSearchToShow("");
              }
              setSearchState(evt.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setParentID({
                  id: null,
                  name: "",
                  scrolParent: { top: 0, left: 0 },
                });
                setSearchToShow(searchState);
              }
            }}
          />
          <Box>
            <IconButton
              sx={{ p: 0, m: 1 }}
              onClick={() => {
                setProgress(true);
                getGroupList(
                  searchToShow,
                  (productgroups) => {
                    setProgress(false);
                    setFiltered(productgroups.productGroups);
                  },
                  false
                );
              }}
            >
              <CachedIcon />
            </IconButton>
            <IconButton sx={{ p: 0 }} href="/productgroups" target="_blank">
              <LinkIcon />
            </IconButton>
          </Box>
        </Box>
        <DataGrid
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            "& .muirtl-s1v7zr-MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !Important",
            },
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .primary": {
              width: "100%",
              backgroundColor: "#ECF6E7 !important",
            },
            "& .none": {
              width: "100%",
              backgroundColor: "#fff !important",
            },
            "& .secondary": {
              width: "100%",
              backgroundColor: "#e9d8f2 !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.id == level4.groupID) {
              return "secondary";
            }
            if (params.row.id == parentID.id) {
              return "primary";
            }
            if (params.row.id !== parentID.id) {
              return "none";
            }
            if (params.row.id == props.product.groupID) {
              return "secondary";
            }
          }}
          columns={columns}
          rows={filtered ? filtered : []}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          hideFooter
        />
      </Box>
      <Box
        sx={{ mt: isSmall ? 7 : 0 }}
        gridColumn={isSmall ? "span 12" : "span 6"}
      >
        <ProductGroupsChilds
          searchToShow={searchToShow}
          setSearchToShow={setSearchToShow}
          parentID={parentID}
          ProductGroup
          groupID={level4.groupID}
          Offer
          setGroupID={gotStoreId}
          PageScrollTo={PageScrollTo}
          setPageScrollTo={setPageScrollTo}
        />
      </Box>
    </Box>
  );
}
